import {
  SET_FORM_ANSWERS,
  SET_FORM_ERRORS,
  SET_ORDER,
  SET_STEPS,
} from "../constants/index";

const initialState = {
  errors: {},
  answers: {},
};

const initAnswers = form => {
  const questionsArray = form.steps.flatMap(step => step.questions || step);

  const answers = questionsArray.reduce(
    (prev, { answerDataType, answer, code }) => {
      let initialAnswer;

      if (answerDataType === "boolean") initialAnswer = answer;
      else if (answer !== undefined) initialAnswer = answer;
      else initialAnswer = "";

      return {
        ...prev,
        [code]: initialAnswer,
      };
    },
    {}
  );

  return answers;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_STEPS:
      return {
        ...state,
        steps: action.payload,
      };

    case SET_FORM_ANSWERS: {
      return {
        ...state,
        answers: action.payload,
      };
    }

    case SET_FORM_ERRORS:
      return {
        ...state,
        errors: action.payload,
      };

    case SET_ORDER:
      if (action.payload.form) {
        return {
          ...state,
          ...action.payload.form,
          answers: initAnswers(action.payload.form),
        };
      }

    default:
      return state;
  }
};
